export enum CONSTANTS {
  SYSTEM = '0001',
  SYSTEM_DESCRIPTION = 'UNC - Dashboard',
}
